import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const withdrwalDoneSearchSchema = z.object({
  customerName: z.string().optional(),
  customerSurname: z.string().optional(),
  amount: z.number().optional(),
  paymentType: z.string().or(z.number()).optional(),
  transactionTstamp: z.string().optional(),
});

export const Route = createFileRoute(
  '/_auth/_layout_with_navbar/withdrawal-done',
)({
  validateSearch: zodValidator(withdrwalDoneSearchSchema),
});
